import { isAccountEligibleForForm1099Box } from "@common/constants/domains/accounting/form1099Box";
import { DraftAccount } from "./draftState";

// Template rows never link a financial account, so eligibility is decided by
// type + origin alone (same rule the apply step uses when it stamps the box).
export const isDraftAccountEligibleForForm1099Box = (
    account: DraftAccount,
): boolean =>
    isAccountEligibleForForm1099Box({
        type: account.type,
        isManuallyCreated: account.isManuallyCreated,
        financialAccountId: null,
    });

// A retype can land an account on a type that cannot hold a box; drop the stale
// value so it is neither shown nor saved (apply nulls it for those types too).
export const clearIneligibleForm1099Box = (
    account: DraftAccount,
): DraftAccount =>
    account.form1099Box != null &&
    !isDraftAccountEligibleForForm1099Box(account)
        ? { ...account, form1099Box: null }
        : account;
